/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getPostThread'

export { $nsid }

/** Get posts in a thread. Does not require auth, but additional metadata and filtering will be applied for authed requests. */
const main = l.query(
  $nsid,
  l.params({
    uri: l.string({ format: 'at-uri' }),
    depth: l.optional(
      l.withDefault(l.integer({ minimum: 0, maximum: 1000 }), 6),
    ),
    parentHeight: l.optional(
      l.withDefault(l.integer({ minimum: 0, maximum: 1000 }), 80),
    ),
  }),
  l.jsonPayload({
    thread: l.typedUnion(
      [
        l.typedRef<FeedDefs.ThreadViewPost>(
          (() => FeedDefs.threadViewPost) as any,
        ),
        l.typedRef<FeedDefs.NotFoundPost>((() => FeedDefs.notFoundPost) as any),
        l.typedRef<FeedDefs.BlockedPost>((() => FeedDefs.blockedPost) as any),
      ],
      false,
    ),
    threadgate: l.optional(
      l.ref<FeedDefs.ThreadgateView>((() => FeedDefs.threadgateView) as any),
    ),
  }),
  ['NotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
